// extracted by mini-css-extract-plugin
module.exports = {"item":"levels_item__2oDdV","active":"levels_active___SVS7","desc":"levels_desc__2s_3d","opt":"levels_opt__a7m1W"};